import { FC, PropsWithChildren, useEffect } from "react";

import { Sheet } from "@/components/_templates/sheet/sheet";
import { useRightAsideStore } from "@/stores/right-aside-store";

export const FixedAside: FC<PropsWithChildren<{ isDisabled?: boolean }>> = ({ children, isDisabled = false }) => {
  const { registerAside, unregisterAside } = useRightAsideStore();

  useEffect(() => {
    if (isDisabled) {
      return;
    }
    registerAside();
    return () => unregisterAside();
  }, [isDisabled, registerAside, unregisterAside]);

  if (isDisabled) {
    return null;
  }

  return <Sheet reserveSpace={false}>{children}</Sheet>;
};
